import { fetcher } from '@commenda/utils';
import type { AdminPylonAccountSummary } from './useAdminCompanyExternalConnections';

export interface SearchAdminPylonAccountsParams {
  query: string;
  limit?: number;
}

export async function searchAdminPylonAccounts({
  query,
  limit = 10,
}: SearchAdminPylonAccountsParams): Promise<AdminPylonAccountSummary[]> {
  const params = new URLSearchParams({
    query,
    limit: String(limit),
  });

  const response = await fetcher(
    `admin/external-connections/pylon/accounts/search?${params.toString()}`,
    { method: 'GET' }
  );

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: unknown;
      error?: unknown;
    } | null;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : Array.isArray(body?.message)
          ? body.message.join(', ')
          : typeof body?.error === 'string'
            ? body.error
            : 'Failed to search Pylon accounts';
    throw new Error(message);
  }

  return response.json();
}
